<template>
    <div class="box-message"></div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('noticeSystem', ['message', 'confirm'])
    },
    watch: {
        'message.isShowMessage': function (val) {
            if (val) {
                let { message } = this;
                this.$message({
                    showClose: message.showClose,
                    message: message.message,
                    type: message.type
                });
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    type: 'success',
                    message: 'Close',
                    isShowMessage: false
                });
            }
        },
        'confirm.isShowConfirm': function (val) {
            if (val) {
                let { confirm } = this;
                this.$confirm(this.$t(confirm.message), this.$t('titleConfirm'), {
                    confirmButtonText: this.$t('button.ok'),
                    cancelButtonText: this.$t('button.cancel'),
                    type: confirm.type
                })
                    .then(() => {
                        if (typeof confirm.callback === 'function') {
                            confirm.callback();
                        }
                        this.$store.commit('noticeSystem/SET_CONFIRM', {
                            isShowConfirm: false,
                            message: 'Close Confirm'
                        });
                    })
                    .catch(() => {
                        this.$store.commit('noticeSystem/SET_CONFIRM', {
                            isShowConfirm: false,
                            message: 'Close Confirm'
                        });
                    });
            }
        }
    }
};
</script>
<style lang="scss"></style>
